import { render, staticRenderFns } from "./ChangeNetWorkPover.vue?vue&type=template&id=f5fa4e48&scoped=true"
import script from "./ChangeNetWorkPover.vue?vue&type=script&lang=js"
export * from "./ChangeNetWorkPover.vue?vue&type=script&lang=js"
import style0 from "./ChangeNetWorkPover.vue?vue&type=style&index=0&id=f5fa4e48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fa4e48",
  null
  
)

export default component.exports